module.exports = __webpack_public_path__ + "img/stema_jud-cluj.ed4a3de7.png";